/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoAllergiaUpdateDTO
 */
export interface AssistitoAllergiaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaUpdateDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaUpdateDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoAllergiaUpdateDTO interface.
 */
export function instanceOfAssistitoAllergiaUpdateDTO(value: object): value is AssistitoAllergiaUpdateDTO {
    return true;
}

export function AssistitoAllergiaUpdateDTOFromJSON(json: any): AssistitoAllergiaUpdateDTO {
    return AssistitoAllergiaUpdateDTOFromJSONTyped(json, false);
}

export function AssistitoAllergiaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoAllergiaUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoAllergiaUpdateDTOToJSON(value?: AssistitoAllergiaUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

